import React, {Component} from 'react'
import {connect} from 'react-redux'

import VoteList from '../components/VoteList'

@connect(state => ({votes: state.votes.my.votes, page: state.votes.my.page, count: state.votes.my.count}))
export default class MyVotes extends Component {

  render() {
    return <VoteList votes={this.props.votes}
                        page={this.props.page}
                        count={this.props.count}
                        pagerHash='v3'
                        pageParamName='puslapis3' gameType={this.props.gameType} />
  }
}
